export default {
      id: "file-type-archived-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#file-type-archived",
      toString: function () {
        return this.url;
      }
    }